<template>
    <div class="ssv-form">
        <div v-if="extended" class="input-item">
            <div class="input-item">
                <label class="label" for="name">Jméno</label>
                <input class="input input--l" type="text" id="name" v-model="name">
                <ssv-order-error-field field="contactInformation.name"/>
            </div>

            <div class="input-item">
                <label class="label" for="surname">Přijmení</label>
                <input class="input input--l" type="text" id="surname" v-model="surname">
                <ssv-order-error-field field="contactInformation.surname"/>
            </div>
        </div>

        <div class="input-item">
            <div class="float--left width250">
                <label class="label" for="phone">Telefon</label>
                <input class="input input--s" type="phone" id="phone" v-model="phone">
                <ssv-order-error-field field="contactInformation.phone"/>
            </div>
            <span class="input__description text--small" v-if="!hideDescriptions">
                {{labels.phone}}
            </span>
        </div>

        <div class="input-item">
            <div class="float--left width250">
                <label class="label" for="email">E-mail</label>
                <input class="input input--l" type="email" id="email" v-model="email">
                <ssv-order-error-field field="contactInformation.email"/>
            </div>
            <span class="input__description text--small" v-if="!hideDescriptions">
                {{labels.email}}
            </span>
        </div>

        <div class="input-item" v-if="sameParticipant">
            <label class="checkbox" for="sameParticipant">
                <input type="checkbox" class="checkbox__native" id="sameParticipant" v-on:change="copyToParticipant">
                Jsem zároveň účastník kurzu
                <span class="checkbox__control"></span>
            </label>
        </div>

        <div class="input-item" v-if="mktCommunication">
            <label class="checkbox" for="mktApproval">
                <input type="checkbox" class="checkbox__native" id="mktApproval"
                       v-model="mktApproval"> Souhlasím se zasíláním aktuálních informací o produktech a dalších
                sdělení.
                <span class="checkbox__control"></span>
            </label>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';
    import {mapActions} from 'vuex';
    import {isPhone, isEmail} from '../../../helpers/validation';
    import SsvOrderErrorField from '../error/ErrorField';

    export default {
        name:       'SsvOrderContactInformationForm',
        components: {
            SsvOrderErrorField
        },
        props:      {
            required:         {
                type:    Boolean,
                default: false,
            },
            extended:         {
                type:    Boolean,
                default: false,
            },
            mktCommunication: {
                type:    Boolean,
                default: false,
            },
            sameParticipant:  {
                type:    Boolean,
                default: false,
            },
            hideDescriptions: {
                type:    Boolean,
                default: false,
            },
            labels: {
                type: Object,
                required: true
            }
        },
        computed:   {
            ...mapFields('ssvOrder', [
                'contactInformation.name',
                'contactInformation.surname',
                'contactInformation.phone',
                'contactInformation.email',
                'contactInformation.mktApproval',
            ]),
        },
        methods:    {
            ...mapActions('ssvOrder', ['setError', 'setParticipantField']),
            copyToParticipant(e) {
                if (e.target.checked) {
                    this.setParticipantField({ index: 0, name: 'name', value: this.name });
                    this.setParticipantField({ index: 0, name: 'surname', value: this.surname });
                    this.setParticipantField({ index: 0, name: 'phone', value: this.phone });
                    this.setParticipantField({ index: 0, name: 'email', value: this.email });
                } else {
                    this.setParticipantField({ index: 0, name: 'name', value: null });
                    this.setParticipantField({ index: 0, name: 'surname', value: null });
                    this.setParticipantField({ index: 0, name: 'phone', value: null });
                    this.setParticipantField({ index: 0, name: 'email', value: null });
                }
            },
            validate() {
                if ((this.required && this.extended) && (!this.name || this.name.length === 0)) this.setError({
                    msg: 'Zadejte jméno',
                    key: 'contactInformation.name'
                });
                if ((this.required && this.extended) && (!this.surname || this.surname.length === 0)) this.setError({
                    msg: 'Zadejte přijmení',
                    key: 'contactInformation.surname'
                });
                if (this.required && (!this.phone || this.phone.length === 0)) this.setError({
                    msg: 'Zadejte kontaktní telefon',
                    key: 'contactInformation.phone'
                });
                if (this.required && (!this.email || this.email.length === 0)) this.setError({
                    msg: 'Zadejte kontaktní e-mail',
                    key: 'contactInformation.email'
                });
                if (this.phone && this.phone.length !== 0 && !isPhone(this.phone)) this.setError({
                    msg: 'Zadaný telefon není v ideální kondici',
                    key: 'contactInformation.phone'
                });
                if (this.email && this.email.length !== 0 && !isEmail(this.email)) this.setError({
                    msg: 'Zadaný e-mail není v ideální kondici',
                    key: 'contactInformation.email'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/contact-information/ContactInformationForm.vue